<template>
  <a-modal
    wrapClassName="customModal"
    v-model="showSelectDialog"
    title="选择课堂"
    centered
    :width="932"
    destroyOnClose
    :maskClosable="false"
    @ok="confirmChoose"
    @cancel="afterClose"
  >
    <div class="reselect-dislog-body">
      <div class="top">
        <div class="current-filter text-overflow-one">{{ this.currentFilterBuildingName.join(',') }}</div>
        <a-input-search
          placeholder="请输入关键字"
          :v-model="keywords"
          style="width: 240px; height: 32px"
          @search="onSearch"
        />
      </div>
      <div class="table-list">
        <a-table
          :columns="tableCloumns"
          :data-source="liveList"
          :scroll="{ y: 280 }"
          :row-key="(record, index) => record.liveId"
          :pagination="false"
          :row-selection="{
            selectedRowKeys: selectedRowKeysArray,
            onChange: onSelectChange,
            type: 'radio'
          }"
        >
          <template slot="liveStatus" slot-scope="liveStatus">
            <div class="live-status">
              {{ liveStatus == 1 ? '进行中' : '已结束' }}
            </div>
          </template>
          <template slot="time" slot-scope="text, record">
            <span>
              {{
                $tools.formatDate(record.startTime, 'YYYY/MM/DD HH:mm') +
                '-' +
                $tools.formatDate(record.endTime, 'HH:mm')
              }}
            </span>
          </template>
        </a-table>
        <a-row type="flex" justify="center" style="margin-top: 30px">
          <a-pagination
            v-if="pageData.total > 0"
            :default-current="1"
            :total="pageData.total"
            :defaultPageSize="pageData.pageSize"
            :show-total="(total) => `共 ${total} 条`"
            :page-size-options="pageSizeOptions"
            show-size-changer
            show-quick-jumper
            @change="handlePageChange"
            @showSizeChange="onShowSizeChange"
            v-model="pageData.pageNum"
            :pageSize.sync="pageData.pageSize"
          />
        </a-row>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    showSelectDialogProp: {
      type: Boolean,
      default: false
    },
    screenFilter: {
      type: Object
    },
    currentScreenItem: {
      type: Object
    },
    panoramaClassroomCode: {
      type: String | Number
    }
  },
  computed: {
    ...mapGetters('switchingSchool', ['schoolSelect', 'schoolSelectName'])
  },
  watch: {
    showSelectDialogProp(val, old) {
      this.showSelectDialog = val
      if (val == true) {
        this.getReselectLiveList(1)
      }
    },
    schoolSelect: {
      handler: async function (newVal) {
        if (!newVal) return
        return newVal
      },
      immediate: true
    }
  },
  mounted() {
    this.getCurrentBuildingName()
  },
  data() {
    return {
      liveList: [],
      tableCloumns: [
        {
          title: '直播名称',
          dataIndex: 'liveName',
          key: 'liveName',
          width: '160px',
          ellipsis: true,
          scopedSlots: { customRender: 'liveName' }
        },
        {
          title: 'ID',
          dataIndex: 'liveId',
          key: 'liveId',
          scopedSlots: { customRender: 'liveId' }
        },
        {
          title: '状态',
          key: 'liveStatus',
          dataIndex: 'liveStatus',
          scopedSlots: { customRender: 'liveStatus' }
        },
        {
          title: '主讲教室',
          dataIndex: 'classroomName',
          key: 'classroomName',
          width: '160px',
          ellipsis: true,
          scopedSlots: { customRender: 'classroomName' }
        },
        {
          title: '直播时间',
          dataIndex: 'time',
          key: 'time',
          width: '200px',
          scopedSlots: { customRender: 'time' }
        }
      ],
      pageSizeOptions: ['5', '10', '15', '20'],
      pageData: {
        total: 0,
        pageSize: 5,
        pageNum: 1
      },
      showSelectDialog: false,
      selectedItem: null,
      selectedRowKeysArray: [],
      keywords: '',
      currentFilterBuildingName: []
    }
  },
  methods: {
    getCurrentBuildingName() {
      let buildFilterOptions = this.screenFilter.buildFilterOptions
      buildFilterOptions.map((item) => {
        if (this.screenFilter.filterOptions.includes(item.id)) {
          this.currentFilterBuildingName.push(item.buildingName)
        }
      })
    },
    async getReselectLiveList(page) {
      const { code, rt } = await this.$http.getReselectLiveList({
        pageNum: page,
        pageSize: this.pageData.pageSize,
        schoolCode: this.schoolSelect,
        filterType: 1,
        filterOptions: this.screenFilter.filterOptions.join(','),
        keywords: this.keywords
      })
      console.log('reselectList', rt)
      this.liveList = rt.list || []
      this.pageData.total = +rt.totalCount
    },
    afterClose() {
      this.pageData.pageNum = 1
      this.$emit('update:showSelectDialogProp', false)
    },
    onSearch(value) {
      console.log(value)
      this.keywords = value
      this.getReselectLiveList(1)
    },
    handlePageChange(page, pageSize) {
      this.pageData.pageNum = page
      this.pageData.pageSize = pageSize
      this.getReselectLiveList(page)
    },
    onShowSizeChange(current, size) {
      this.pageData.pageSize = size
      this.getReselectLiveList(1)
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeysArray = selectedRowKeys
      this.selectedItem = selectedRows
      console.log('selectedRowKeys', selectedRowKeys, selectedRows)
    },
    confirmChoose() {
      if (!this.selectedItem) return this.$message.error('当前没有选中的直播')
      this.setReselectLive()
    },
    async setReselectLive() {
      console.log('screenId', this.currentScreenItem)
      const res = await this.$http.reselectLive({
        screenId: this.currentScreenItem.screenId,
        liveId: this.selectedItem[0].liveId,
        panoramaClassroomCode: this.panoramaClassroomCode || undefined
      })
      if (res.code == 200) {
        this.selectedItem[0].screenId = this.currentScreenItem.screenId
        this.selectedItem[0].screenSort = this.currentScreenItem.screenSort
        this.selectedItem[0].largeScreenChecked = this.currentScreenItem.largeScreenChecked

        console.log('this.selectedItem', this.selectedItem[0])
        this.$message.success('操作成功')
        this.$emit('updateLiveList', this.selectedItem[0])
        this.pageData.pageNum = 1
        this.$emit('update:showSelectDialogProp', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.reselect-dislog-body {
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .current-filter {
      max-width: 640px;
      font-size: 20px;
      color: #515560;
    }
  }
  .table-list {
    margin-top: 26px;
    .live-status {
      width: 52px;
      height: 20px;
      font-size: 12px;
      line-height: 20px;
      border: 1px solid #00cf96;
      color: #00cf96;
      text-align: center;
    }
  }
}
::v-deep .ant-modal-body {
  padding: 24px 16px;
}
::v-deep .ant-modal-footer {
  padding: 20px;
  border-top: none;
  text-align: center;
  .ant-btn {
    width: 108px;
    height: 38px;
    border: 1px solid #5f60d3;
    color: #5f60d3;
  }
  .ant-btn-primary {
    margin-left: 16px;
    background: #5f60d3;
    color: #fff;
  }
}
::v-deep {
  .ant-radio-checked {
    .ant-radio-inner {
      border-color: #5f60d3;
      &::after {
        background-color: #5f60d3;
      }
    }
  }
  .ant-pagination-item-active {
    background: #5f60d3;
    border-color: #5f60d3;
    &:hover a {
      color: #fff !important;
    }
    a {
      color: #fff;
    }
  }
  .ant-pagination-item:hover {
    border-color: #5f60d3;
    a {
      color: #5f60d3;
    }
  }
  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    &:hover {
      border-color: #5f60d3;
      color: #5f60d3;
    }
  }
  .ant-select-selection {
    &:hover {
      border-color: #5f60d3;
    }
    &:focus {
      box-shadow: 0 0 0 2px rgba(95, 96, 211, 0.2);
    }
  }

  .ant-select-open .ant-select-selection {
    border-color: #5f60d3;
    box-shadow: 0 0 0 2px rgba(95, 96, 211, 0.2);
  }

  .ant-pagination-options-quick-jumper input {
    &:focus {
      border-color: #5f60d3;
      box-shadow: 0 0 0 2px rgba(95, 96, 211, 0.2);
    }
    &:hover {
      border-color: #5f60d3;
    }
  }
}
</style>
